import http from '../http'

const BASE_URL = 'rol'

class RoleAPI {

  async getAll() {
    const response = await http(`${BASE_URL}`)
    return response || null
  }

}

export default new RoleAPI()